export default {"src":"/_next/static/media/australia.0d5f88ac.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};